module.exports = __webpack_public_path__ + "img/Icon - Datacomm.6663e64e.png";